import { ImageScaleView, ViewOpts } from '@play-co/timestep-core/ui';
import { Match2ShopBundlesIcon } from './Match2ShopBundlesIcon';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';

export class Match2ShopBundlesPackRewards extends ImageScaleView {
  constructor(opts: ViewOpts) {
    super({
      width: 140,
      height: 140,
      image: 'assets/ui/match2/shopbundles/shopbundles_rounded_rect.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
      ...opts,
    });
  }

  public setup(rewards: Match2Reward[], large?: boolean) {
    const icons: Match2ShopBundlesIcon[] = [];

    for (const reward of rewards) {
      const icon = new Match2ShopBundlesIcon({
        superview: this,
      });
      icon.setup(reward);
      icons.push(icon);
    }

    if (icons.length === 1) {
      if (large) {
        this.updateOpts({ width: 140 });
        icons[0].updateOpts({ x: 70, y: 70, scale: 1.2 });
      } else {
        this.updateOpts({ width: 70 });
        icons[0].updateOpts({ x: 35, y: 70 });
      }
    }

    if (icons.length === 2) {
      this.updateOpts({ width: 70 });
      icons[0].updateOpts({ x: 35, y: 35 });
      icons[1].updateOpts({ x: 35, y: 100 });
    }

    if (icons.length === 3) {
      this.updateOpts({ width: 140 });
      icons[0].updateOpts({ x: 38, y: 35 });
      icons[1].updateOpts({ x: 102, y: 35 });
      icons[2].updateOpts({ x: 70, y: 100 });
    }

    if (icons.length === 4) {
      this.updateOpts({ width: 140 });
      icons[0].updateOpts({ x: 38, y: 35 });
      icons[1].updateOpts({ x: 102, y: 35 });
      icons[2].updateOpts({ x: 38, y: 100 });
      icons[3].updateOpts({ x: 102, y: 100 });
    }
  }
}
